import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { EmployeeType, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const EMPLOYEES_ROOT = ['employees'] as const;

interface EmployeesListParams {
    companyId: number;
}

const fetchers = {
    list: {
        key: ({ companyId }: EmployeesListParams) => [...EMPLOYEES_ROOT, 'list', companyId] as const,
        fetch: async ({ companyId }: EmployeesListParams): Promise<EmployeeType[]> => {
            const response: ResponseType<EmployeeType[]> = await request(`companies/${companyId}/users`);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const employeesEntity: EntityDefinition<typeof fetchers> = {
    name: 'employees',
    roots: [EMPLOYEES_ROOT],
    fetchers,
};

export const useEmployeesList = createEntityQuery(employeesEntity, 'list');

export type { EmployeesListParams };
